<template>
  <div>
    <div class="search-bar-margin-bottom-cla">
      <el-form :inline="true"
               ref="formValidate"
               :model="params"
               label-position="right">
        <el-form-item :label="$t('user.startTime')"
                      prop="createTime_start">
          <el-date-picker v-model="params.createTime_start"
                          type="date"
                          :placeholder="$t('common.selectDate')"
                          :picker-options="pickerOptionsStart"></el-date-picker>
        </el-form-item>

        <el-form-item :label="$t('user.endTime')"
                      prop="createTime_end">
          <el-date-picker v-model="params.createTime_end"
                          type="date"
                          :placeholder="$t('common.selectDate')"
                          :picker-options="pickerOptionsEnd"></el-date-picker>
        </el-form-item>

        <el-form-item :label="$t('user.status')"
                      prop="type">
          <zk-dictionary-select type="status"
                                v-model="params.status"
                                clearable
                                :placeholder="$t('common.select')"></zk-dictionary-select>
        </el-form-item>

        <el-form-item :label="$t('user.account')"
                      prop="loginName">
          <el-input v-model.trim="params.loginName"
                    :placeholder="this.$t('common.inputUserName')">
            <el-button slot="append"
                       style="float: left;"
                       @click="query"
                       icon="search">{{ $t('common.search') }}</el-button>
          </el-input>
        </el-form-item>
      </el-form>
    </div>

    <div class="black_panel_cla">
      <div class="header-button-bar">
        <ZkButtonGroup :isGroup="true"
                       :event="events"
                       @add="add"
                       @update="update"
                       @remove="remove"
                       @resetPwd="resetPwd"
                       @freeze="freeze"
                       @unfreeze="unfreeze"
                       @allotRole="allotRole"
                       @detail="detail"></ZkButtonGroup>
      </div>

      <zk-table :columns="columnData"
                :data="userData"
                @current-change="selected"
                ref="userTable"
                stripe
                border></zk-table>

      <div class="pagination-margin-top">
        <el-pagination background
                       @size-change="changePageSize"
                       @current-change="changePage"
                       :current-page="pager.curPage"
                       :page-size="pager.pageSize"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pager.total"></el-pagination>
      </div>
    </div>

    <el-dialog :title="state.title"
               :visible.sync="state.saveOrUpdate"
               :before-close="saveOrUpdateCancel"
               width="50%">
      <zk-user-save-or-update ref="saveOrUpdate"
                              :form="currentRow"
                              :isUpdate="state.isUpdate"
                              :treeData="treeData"
                              :deptArr="deptArr"
                              :row="row"></zk-user-save-or-update>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="saveOrUpdateCancel">{{
          $t('common.cancel')
        }}</el-button>
        <el-button type="primary"
                   @click="saveOrUpdate">{{
          $t('common.confirm')
        }}</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="state.title"
               :visible.sync="state.allotUserRole"
               :before-close="allotUserRoleCancel"
               width="45%">
      <zk-user-allot-role ref="allotUserRole"
                          :roleData="roleData"
                          :roleArr="roleArr"
                          :userId="userId"></zk-user-allot-role>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="allotUserRoleCancel">{{
          $t('common.cancel')
        }}</el-button>
        <el-button type="primary"
                   @click="allotUserRole">{{
          $t('common.confirm')
        }}</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="state.title"
               :visible.sync="state.detail"
               :before-close="detailClose"
               width="45%">
      <zk-user-detail :userDetail="currentRow"></zk-user-detail>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="detailClose">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary"
                   @click="detailClose">{{
          $t('common.confirm')
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import * as userService from '../../../services/user.js'
import { queryRoleTree } from '../../../services/role'
import { getAllChildren } from '../../../services/organization'
import {
  dateFormat,
  dateByTimestamp,
  isEmpty,
  emailFormat,
  phoneFormat
} from '../../../utils/index.js'
export default {
  name: 'ZkUserManager',
  data () {
    let _self = this
    let treeData = []
    let params = {
      createTime_start: '',
      createTime_end: '',
      loginName: '',
      status: ''
    }
    let columnData = [
      {
        label: this.$t('user.account'),
        prop: 'loginName'
      },
      {
        label: this.$t('user.userName'),
        prop: 'name',
        render (h, params) {
          return h('span', _self.isEmpty(params.row.name))
        }
      },
      {
        label: this.$t('user.email'),
        prop: 'email',
        render (h, params) {
          let res = emailFormat(params.row.email)
          return h('span', _self.isEmpty(res))
        }
      },
      {
        label: this.$t('user.phone'),
        prop: 'phone',
        render (h, params) {
          let res = phoneFormat(params.row.phone)
          return h('span', _self.isEmpty(res))
        }
      },
      {
        label: this.$t('user.registerTime'),
        prop: 'createTime',
        render: (h, params) => {
          return h(
            'span',
            dateFormat(dateByTimestamp(params.row.createTime), null)
          )
        }
      },
      {
        label: this.$t('user.status'),
        prop: 'status',
        render: (h, params) => {
          return h('zk-dictionary-transform', {
            key: params.row.id + params.row.status,
            props: {
              value: params.row.status,
              type: 'status'
            }
          })
        }
      }
    ]
    let userData = []
    let defaultProps = {
      children: 'children',
      label: 'name'
    }
    let state = {
      isUpdate: false,
      title: '',
      saveOrUpdate: false,
      allotUserRole: false,
      detail: false
    }
    let roleData = []
    return {
      treeData,
      params,
      pickerOptionsEnd: {
        disabledDate: time => {
          if (this.params.createTime_start) {
            return time.getTime() < new Date(this.params.createTime_start).getTime()
          }
        }
      },
      pickerOptionsStart: {
        disabledDate: item => {
          if (this.params.createTime_end) {
            return item.getTime() > new Date(this.params.createTime_end).getTime()
          }
        }
      },
      columnData,
      userData,
      defaultProps,
      state,
      currentRow: null,
      deptArr: [],
      roleArr: [],
      roleData,
      userId: '',
      row: []
    }
  },
  computed: {
    events: function () {
      if (this.currentRow && this.currentRow.status === 1) {
        return [
          'add',
          'update',
          'remove',
          'resetPwd',
          'allotRole',
          'detail',
          'freeze'
        ]
      } else if (this.currentRo && this.currentRow.status === 0) {
        return [
          'add',
          'update',
          'remove',
          'resetPwd',
          'allotRole',
          'detail',
          'unfreeze'
        ]
      } else {
        return [
          'add',
          'update',
          'remove',
          'resetPwd',
          'allotRole',
          'detail',
          'freeze',
          'unfreeze'
        ]
      }
    }
  },
  methods: {
    getResetPassword () {
      let resetPassword = '' // 容器
      for (var i = 0; i < 6; i++) {
        // 循环六次
        var num = Math.random() * 9 // Math.random();每次生成(0-1)之间的数;
        num = parseInt(num, 10)
        resetPassword += num
      }
      return resetPassword
    },
    query () {
      this.pager.curPage = 1
      this.commQuery()
    },
    commQuery () {
      if (
        !isEmpty(this.params.createTime_start) &&
        this.params.createTime_start instanceof Date
      ) {
        this.params.createTime_start = this.params.createTime_start.getTime()
      }
      if (
        !isEmpty(this.params.createTime_end) &&
        this.params.createTime_end instanceof Date
      ) {
        this.params.createTime_end = this.params.createTime_end.getTime()
      }
      userService
        .queryUserList({
          params: this.params,
          pager: this.pager
        })
        .then(data => {
          if (data.code === '00000000') {
            this.userData = data.payload.results.results || data.payload.results
            this.$refs.userTable.setCurrentRow(this.userData[0])
            this.pager.curPage =
              data.payload.results.curPage || data.payload.curPage
            this.pager.total =
              data.payload.results.totalRecords || data.payload.totalRecords
            this.pager.pageSize =
              data.payload.results.pageSize || data.payload.pageSize
          }
        })
        .catch()
    },
    changePageSize (pageSize) {
      this.pager.pageSize = pageSize
      this.commQuery()
    },
    changePage (current) {
      this.pager.curPage = current
      this.commQuery()
    },
    add (row) {
      this.$refs.userTable.setCurrentRow(row)
      // this.currentRow = {}
      this.deptArr = []
      this.state.isUpdate = false
      this.state.title = this.$t('user.addUser')
      this.state.saveOrUpdate = true
    },
    saveOrUpdateCancel (row) {
      this.state.saveOrUpdate = false
      this.$refs.userTable.setCurrentRow(row)
      // this.currentRow = {}
      this.$refs.saveOrUpdate.resetFields()
    },
    allotUserRoleCancel (row) {
      this.state.allotUserRole = false
      this.$refs.userTable.setCurrentRow(row)
      // this.currentRow = {}
    },
    detailClose (row) {
      this.state.detail = false
      this.$refs.userTable.setCurrentRow(row)
      // this.currentRow = {}
    },
    saveOrUpdate () {
      let _self = this
      this.$refs.saveOrUpdate
        .save()
        .then(data => {
          if (data.code === '00000000') {
            _self.$message({
              type: 'success',
              message: this.state.title + ' ' + this.$t('common.success')
            })
            _self.state.saveOrUpdate = false
            this.commQuery()
          } else {
            _self.$message({
              type: 'error',
              message: data.message
            })
            _self.state.saveOrUpdate = true
          }
        })
        .catch(data => {
          if (data) {
            _self.$message({
              type: 'error',
              message: data.message
            })
          }
        })
    },
    update (row) {
      if (this.currentRow && this.currentRow.id) {
        // 超级管理员不允许修改
        if (this.currentRow.id === '00000000000000000000000000000000') {
          this.$message({
            type: 'error',
            message: this.$t('user.notAllowToChange')
          })
          return
        }
        this.state.isUpdate = true
        this.state.title = this.$t('user.modifyUser')
        this.state.saveOrUpdate = true
        this.getDeptsByUserId(this.currentRow.id)
      } else {
        this.$message({
          type: 'warning',
          message: this.$t('user.select1record')
        })
      }
    },
    remove () {
      if (this.currentRow && this.currentRow.id) {
        // 超级管理员不允许删除
        if (this.currentRow.id === '00000000000000000000000000000000') {
          this.$message({
            type: 'error',
            message: this.$t('user.notAllowToRemove')
          })
          return
        }
        this.$confirm(
          this.$tc('user.confirmDeleteTip', 1) +
          ' ' +
          this.currentRow.loginName +
          this.$tc('user.confirmDeleteTip', 2),
          this.$t('common.confirmDelete'),
          {
            confirmButtonText: this.$t('common.yes'),
            cancelButtonText: this.$t('common.cancel'),
            type: 'warning'
          }
        )
          .then(() => {
            userService
              .remove({
                userId: this.currentRow.id
              })
              .then(data => {
                if (data.code === '00000000') {
                  this.$message({
                    type: 'success',
                    message: this.$t('common.successDelete')
                  })
                  this.query()
                } else {
                  this.$message({
                    type: 'error',
                    message: data.message
                  })
                }
              })
              .catch(data => {
                this.$message({
                  type: 'error',
                  message: data.message
                })
              })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: this.$t('common.cancelDelete')
            })
          })
      } else {
        this.$message({
          type: 'warning',
          message: this.$t('user.select1record')
        })
      }
    },
    resetPwd () {
      if (this.currentRow.id) {
        // 超级管理员不允许冻结
        if (this.currentRow.id === '00000000000000000000000000000000') {
          this.$message({
            type: 'error',
            message: this.$t('user.notAllowToResetPwd')
          })
          return
        }
        this.$confirm(
          this.$tc('user.confirmResetPwdTip', 1) +
          ' ' +
          this.currentRow.loginName +
          this.$tc('user.confirmResetPwdTip', 2),
          this.$t('user.confirmResetPwd'),
          {
            confirmButtonText: this.$t('common.yes'),
            cancelButtonText: this.$t('common.cancel'),
            type: 'warning'
          }
        )
          .then(() => {
            userService
              .resetPwd({
                userId: this.currentRow.id
              })
              .then(data => {
                if (data.code === '00000000') {
                  this.$message({
                    type: 'success',
                    message: this.$t('user.successResetPwd')
                  })
                } else {
                  this.$message({
                    type: 'error',
                    message: data.message
                  })
                }
              })
              .catch(data => {
                this.$message({
                  type: 'error',
                  message: data.message
                })
              })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: this.$t('user.cancelResetPwd')
            })
          })
      } else {
        this.$message({
          type: 'warning',
          message: this.$t('user.select1record')
        })
      }
    },
    freeze () {
      if (this.currentRow && this.currentRow.id) {
        // 超级管理员不允许冻结
        if (this.currentRow.id === '00000000000000000000000000000000') {
          this.$message({
            type: 'error',
            message: this.$t('user.notAllowToFreeze')
          })
          return
        }
        this.$confirm(
          this.$tc('user.confirmFreezeTip', 1) +
          ' ' +
          this.currentRow.loginName +
          this.$tc('user.confirmFreezeTip', 2),
          this.$t('user.confirmFreeze'),
          {
            confirmButtonText: this.$t('common.yes'),
            cancelButtonText: this.$t('common.cancel'),
            type: 'warning'
          }
        )
          .then(() => {
            userService
              .freeze({
                userId: this.currentRow.id,
                status: 0
              })
              .then(data => {
                if (data.code === '00000000') {
                  this.$message({
                    type: 'success',
                    message: this.$t('user.successFreeze')
                  })
                  this.query()
                } else {
                  this.$message({
                    type: 'error',
                    message: data.message
                  })
                }
              })
              .catch(data => {
                this.$message({
                  type: 'error',
                  message: data.message
                })
              })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: this.$t('user.cancelFreeze')
            })
          })
      } else {
        this.$message({
          type: 'warning',
          message: this.$t('user.select1record')
        })
      }
    },
    unfreeze () {
      if (this.currentRow && this.currentRow.id) {
        if (this.currentRow.status === 1) {
          this.$message({
            type: 'success',
            message: this.$t('user.notNeedUnfreeze')
          })
          return
        }
        this.$confirm(
          this.$tc('user.confirmUnfreezeTip', 1) +
          ' ' +
          this.currentRow.loginName +
          this.$tc('user.confirmUnfreezeTip', 2),
          this.$t('user.confirmUnfreeze'),
          {
            confirmButtonText: this.$t('common.yes'),
            cancelButtonText: this.$t('common.cancel'),
            type: 'warning'
          }
        )
          .then(() => {
            userService
              .unfreeze({
                userId: this.currentRow.id,
                status: 1
              })
              .then(data => {
                if (data.code === '00000000') {
                  this.$message({
                    type: 'success',
                    message: this.$t('user.successUnfreeze')
                  })
                  this.query()
                } else {
                  this.$message({
                    type: 'error',
                    message: data.message
                  })
                }
              })
              .catch(data => {
                this.$message({
                  type: 'error',
                  message: data.message
                })
              })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: this.$t('user.cancelUnfreeze')
            })
          })
      } else {
        this.$message({
          type: 'warning',
          message: this.$t('user.select1record')
        })
      }
    },
    allotRole () {
      if (this.currentRow && this.currentRow.id) {
        // 超级管理员不允许重新分配角色
        if (this.currentRow.id === '00000000000000000000000000000000') {
          this.$message({
            type: 'error',
            message: '超级管理员不允许重新分配角色！'
          })
          return
        }
        this.getRoles()
        this.getRolesByUserId(this.currentRow.id)
        this.state.title = this.$t('user.roleAllot')
        this.state.allotUserRole = true
        this.userId = this.currentRow.id
      } else {
        this.$message({
          type: 'warning',
          message: this.$t('user.select1record')
        })
      }
    },
    allotUserRole () {
      let _self = this
      this.$refs.allotUserRole
        .save()
        .then(data => {
          if (data.code === '00000000') {
            _self.$message({
              type: 'success',
              message: this.state.title + ' ' + this.$t('common.success')
            })
            _self.state.allotUserRole = false
            this.commQuery()
          } else {
            _self.$message({
              type: 'error',
              message: this.state.title + ' ' + this.$t('common.fail')
            })
            _self.state.allotUserRole = true
          }
        })
        .catch(data => {
          _self.$message({
            type: 'error',
            message: data.message
          })
        })
    },
    getRoles () {
      queryRoleTree().then(data => {
        this.roleData = data.payload.results.roleTree
      })
    },
    getDepts () {
      getAllChildren().then(data => {
        this.treeData = data.payload.results.departments
      })
    },
    selected (row) {
      // this.row = row
      this.currentRow = row
      // this.currentRow.email = this.emailFormat(this.currentRow.email)
    },
    getDeptsByUserId (id) {
      userService
        .getDeptsByUserId({
          userId: id
        })
        .then(data => {
          this.deptArr = data.payload.results.deptArr
        })
        .catch(data => { })
    },
    getRolesByUserId (id) {
      userService
        .getRolesByUserId({
          userId: id
        })
        .then(data => {
          this.roleArr = data.payload.results.roleArr
        })
        .catch(data => { })
    },
    detail () {
      if (this.currentRow && this.currentRow.id) {
        this.state.detail = true
        this.state.title = this.$t('user.userDetail')
        userService
          .detail({
            userId: this.currentRow.id
          })
          .then(data => {
            if (data.code === '00000000') {
              this.currentRow = data.payload.results.results
            }
          })
          .catch(data => {
            this.$message({
              type: 'error',
              message: data.message
            })
          })
      } else {
        this.$message({
          type: 'warning',
          message: this.$t('user.select1record')
        })
      }
    },
    beforeClose () { }
  },
  mounted () {
    this.commQuery()
    this.getDepts()
  }
}
</script>



// WEBPACK FOOTER //
// src/cdpBase/baseComponents/userManage/src/main.vue